var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRandstadGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "none",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10c6.078 0 11 4.922 11 11s-4.922 11-11 11-11-4.922-11-11 4.922-11 11-11zm0 2c-4.973 0-9 4.027-9 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9zm-3.463 5.7a.7.7 0 01.523.235l2.173 2.354a.821.821 0 01.217.566v3.995h-1.467v-4.37c0-.658-.492-1.191-1.1-1.191H13.85V17.7zm10.613 0v1.589h-4.033c-.608 0-1.1.533-1.1 1.191v4.37H21.55v-3.995c0-.222.081-.423.217-.566l2.173-2.354a.7.7 0 01.522-.235h3.688z",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 6,
    r: 4,
    fill: "none",
    stroke: "none",
    transform: "translate(5 5)",
    fillOpacity: 0,
    strokeOpacity: 0
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iOCIgc3Ryb2tlPSJub25lIiBmaWxsPSJub25lIiBmaWxsLW9wYWNpdHk9IjAiIHN0cm9rZS1vcGFjaXR5PSIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIi8+CiAgICAgICAgPHBhdGggZD0iTTIxIDEwYzYuMDc4IDAgMTEgNC45MjIgMTEgMTFzLTQuOTIyIDExLTExIDExLTExLTQuOTIyLTExLTExIDQuOTIyLTExIDExLTExem0wIDJjLTQuOTczIDAtOSA0LjAyNy05IDlzNC4wMjcgOSA5IDkgOS00LjAyNyA5LTktNC4wMjctOS05LTl6bS0zLjQ2MyA1LjdhLjcuNyAwIDAgMSAuNTIzLjIzNWwyLjE3MyAyLjM1NGEuODIxLjgyMSAwIDAgMSAuMjE3LjU2NnYzLjk5NWgtMS40Njd2LTQuMzdjMC0uNjU4LS40OTItMS4xOTEtMS4xLTEuMTkxSDEzLjg1VjE3Ljd6bTEwLjYxMyAwdjEuNTg5aC00LjAzM2MtLjYwOCAwLTEuMS41MzMtMS4xIDEuMTkxdjQuMzdIMjEuNTV2LTMuOTk1YzAtLjIyMi4wODEtLjQyMy4yMTctLjU2NmwyLjE3My0yLjM1NGEuNy43IDAgMCAxIC41MjItLjIzNWgzLjY4OHoiIGZpbGwtb3BhY2l0eT0iLjYiLz4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1IDUpIiBmaWxsLW9wYWNpdHk9IjAiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLW9wYWNpdHk9IjAiPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIyNyIgY3k9IjYiIHI9IjQiIHN0cm9rZT0ibm9uZSIgZmlsbD0ibm9uZSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgRandstadGrey as ReactComponent };